// Texty stránok Reklamácia a Odstúpenie — slovenské dvojča locale/cs/retinoPage.js.
// SK: neověřeno ve fixtures (Retino portál na jipos.sk zatím neběží, manifest
// stránky = null; checkMap i portálové texty odvozené z CZ, ne z reálného obsahu).
import { CONTACT } from '../../modules/headerTools.js';

export default {
  labelRetino: 'Zabezpečuje Retino',
  labelLoadingSub: 'Formulár spracúva služba Retino',
  labelFailTitle: 'Portál sa zatiaľ nenačítal',
  labelFailText:
    'Otvorte si portál v novom okne, alebo stránku načítajte znova. Keď nepomôže ani to, napíšte nám a vybavíme to e-mailom.',
  labelFailCta: 'Napísať na ' + CONTACT.email,

  checkMap: [
    { re: /meno|priezvisko/i, icon: 'user', title: 'Meno a priezvisko', desc: 'podľa údajov v objednávke' },
    { re: /e-?mail/i, icon: 'mail', title: 'Váš e-mail', desc: 'kontakt z objednávky' },
    { re: /číslo\s+objednávky/i, icon: 'tag', title: 'Číslo objednávky', desc: 'nájdete v potvrdení objednávky' },
    { re: /číslo\s+účtu/i, icon: 'card', title: 'Číslo účtu', desc: 'pre vrátenie peňazí' },
    { re: /predmet/i, icon: 'package', title: 'Predmet reklamácie', desc: 'reklamovaný tovar' },
    { re: /popis|problém/i, icon: 'chat', title: 'Popis problému', desc: 'čo a ako sa prejavuje' },
  ],

  pages: [
    {
      page: 'claim',
      eyebrow: 'Reklamácia tovaru',
      perex:
        'Reklamáciu vybavíte pohodlne online. Pre čo najrýchlejšie vybavenie si vopred pripravte niekoľko údajov. Vďaka nim reklamáciu spracujeme bez zbytočných otázok.',
      checkTitle: 'Čo si pripravte pred reklamáciou',
      portalIcon: 'shield',
      portalTitle: 'Reklamačný portál',
      portalSub: 'Online vybavenie reklamácie krok za krokom',
      portalLoading: 'Načítavame reklamačný portál',
      portalLoadingText:
        'Vo formulári vyplníte údaje o objednávke a chybe, priložíte fotky a stav reklamácie potom sledujete online.',
      portalCta: 'Začať reklamáciu online',
      stepsTitle: 'Ako reklamácia prebieha',
      steps: [
        { title: 'Vyplňte formulár', desc: 'Zadáte údaje o objednávke a popíšete chybu.' },
        { title: 'Odošlite tovar', desc: 'Zabalíte a pošlete na našu adresu, inštrukcie dostanete v portáli.' },
        { title: 'Posúdime reklamáciu', desc: 'Tovar preskúmame a navrhneme riešenie.' },
        { title: 'Vybavenie a vyrozumenie', desc: 'O výsledku vás informujeme, zvyčajne do 30 dní.' },
      ],
      linkTitle: 'Reklamačný poriadok',
      linkDesc: 'Podmienky a lehoty reklamácie',
      helpTitle: 'Neviete si rady?',
      helpText: 'Poradíme s reklamáciou aj vyplnením. Ozvite sa, radi pomôžeme.',
    },
    {
      page: 'withdrawal',
      eyebrow: 'Vrátenie tovaru',
      perex:
        'Nevyhovuje tovar? Môžete od zmluvy odstúpiť do 14 dní od prevzatia, bez udania dôvodu. Pre rýchle vybavenie si pripravte pár údajov nižšie.',
      stat: {
        num: '14',
        unit: 'dní na vrátenie',
        sub: 'bez udania dôvodu',
        points: [
          'Lehota 14 dní od prevzatia zásielky',
          'Peniaze vrátime do 14 dní od doručenia tovaru',
          'Ideálne nepoškodené a kompletné',
        ],
      },
      checkTitle: 'Čo si pripravte pre odstúpenie od zmluvy',
      portalIcon: 'refresh',
      portalTitle: 'Portál pre vrátenie tovaru',
      portalSub: 'Online odstúpenie od zmluvy krok za krokom',
      portalLoading: 'Načítavame portál pre vrátenie',
      portalLoadingText:
        'Vo formulári zadáte údaje o objednávke a číslo účtu pre vrátenie peňazí. Priebeh potom sledujete online.',
      portalCta: 'Začať vrátenie online',
      stepsTitle: 'Ako vrátenie prebieha',
      steps: [
        { title: 'Vyplňte formulár', desc: 'Do 14 dní od prevzatia tovaru zadáte údaje o objednávke.' },
        { title: 'Odošlite tovar späť', desc: 'Zabalíte a pošlete na našu adresu podľa inštrukcií v portáli.' },
        { title: 'Skontrolujeme tovar', desc: 'Overíme stav vráteného tovaru.' },
        { title: 'Vrátime peniaze', desc: 'Peniaze zašleme na uvedený účet do 14 dní od doručenia späť.' },
      ],
      linkTitle: 'Obchodné podmienky',
      linkDesc: 'Pravidlá odstúpenia od zmluvy',
      helpTitle: 'Máte otázku k vráteniu?',
      helpText: 'Radi poradíme s odstúpením aj vyplnením formulára.',
    },
  ],
};
